import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InterestedParty } from '../../Models/Models/Customer/InterestedParty';

declare var IS_RUNNING_IN_APP_POOL;

export class InterestedPartiesByCustomerClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<InterestedParty>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/InterestedPartiesByCustomer/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<InterestedParty>, any>(url, data);
  }
}

